import Modal from '@components/common/modal'
import Tooltip from '@components/common/tooltip'
import { useSessionContext } from '@contexts/session'
import { SubjectType } from '@lib/constants/billing'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { useState } from 'react'
import { Info } from 'react-feather'

const CreditLogTable = dynamic(() =>
  import('@components/student-dashboard/credit-system/log-table')
)

type Props = {
  subject: SubjectType
  totalCredits: number
}
const CreditCounter = ({ subject, totalCredits }: Props) => {
  const [isCreditTableOpen, setIsCreditTableOpen] = useState(false)
  const { displayCredits } = useSessionContext()

  // Rounds the number to only one decimal place
  const roundOffCredits = (credits: number) => {
    return parseFloat(credits.toFixed(2))
  }

  const TOOLTIP_CONTENT = (
    <div className="text-grey w-96 p-2 font-500 flex flex-col space-y-2 leading-tight">
      <p>
        <b>&quot;Credits left&quot;</b> are count of remaining classes you can
        take for the payment done till now. Every time you attend a class, the
        count decreases by 1.
      </p>
      <p>
        If the <b>&quot;Credits left&quot;</b> becomes zero, you will not be
        able to take further classes. Please always make the payment on time to
        avoid disruption.
      </p>
      <p>Click on the button to view your credit transaction logs.</p>
    </div>
  )

  return (
    <div>
      <div
        className={classNames(
          'flex space-x-2 rounded items-center px-2 py-1 font-600 cursor-pointer hover:shadow',
          {
            'text-green-300 bg-green-50': totalCredits >= 4,
            'text-orange2-400 bg-orange2-50':
              totalCredits < 4 && totalCredits > 0,
            'text-orange bg-orange-200 hidden': !displayCredits,
          }
        )}
        onClick={() => setIsCreditTableOpen(true)}
      >
        <p>
          {subject}: {roundOffCredits(totalCredits)} credits{' '}
        </p>
        <Tooltip
          showOnHover
          placement="bottom-center"
          content={TOOLTIP_CONTENT}
        >
          <Info size="14" />
        </Tooltip>
      </div>

      <Modal
        isOpen={isCreditTableOpen}
        setIsOpen={setIsCreditTableOpen}
        isCrossIconShown
        width="max-w-6xl"
      >
        <CreditLogTable subject={subject} />
      </Modal>
    </div>
  )
}

export default CreditCounter
